var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardListOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 3.33333H4.66659C4.31296 3.33333 3.97382 3.47381 3.72378 3.72386C3.47373 3.97391 3.33325 4.31304 3.33325 4.66667V12.6667C3.33325 13.0203 3.47373 13.3594 3.72378 13.6095C3.97382 13.8595 4.31296 14 4.66659 14H11.3333C11.6869 14 12.026 13.8595 12.2761 13.6095C12.5261 13.3594 12.6666 13.0203 12.6666 12.6667V4.66667C12.6666 4.31304 12.5261 3.97391 12.2761 3.72386C12.026 3.47381 11.6869 3.33333 11.3333 3.33333H9.99992M5.99992 3.33333C5.99992 3.68696 6.14039 4.02609 6.39044 4.27614C6.64049 4.52619 6.97963 4.66667 7.33325 4.66667H8.66658C9.02021 4.66667 9.35935 4.52619 9.60939 4.27614C9.85944 4.02609 9.99992 3.68696 9.99992 3.33333M5.99992 3.33333C5.99992 2.97971 6.14039 2.64057 6.39044 2.39052C6.64049 2.14048 6.97963 2 7.33325 2H8.66658C9.02021 2 9.35935 2.14048 9.60939 2.39052C9.85944 2.64057 9.99992 2.97971 9.99992 3.33333M7.99992 8H9.99992M7.99992 10.6667H9.99992M5.99992 8H6.00659M5.99992 10.6667H6.00659",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardListOutline);
export default __webpack_public_path__ + "static/media/ClipboardListOutline.8de1e9b56baccb3bf6629d3620d6115d.svg";
export { ForwardRef as ReactComponent };